<template>
  <div @click="toDetailCourse" class="th-cart-list cursor-pointer">
    <div class="th-cart-list-image">
      <img
        class="object-cover"
        :width="imgWidth || 60"
        :src="meta.imgSrc ? meta.imgSrc : '/img/thumbnail/empty.png'"
        :alt="meta.title"
      />
      <!-- <img :width="imgWidth || 60" :src="meta.imgSrc" alt="cart" /> -->
    </div>
    <div class="th-cart-list-meta">
      <div
        v-if="(exclude && !exclude.includes('title')) || !exclude"
        class="th-cart-list-meta-title"
      >
        {{ meta.title }}
      </div>
      <div
        v-if="(exclude && !exclude.includes('by')) || !exclude"
        class="th-cart-list-meta-by"
      >
        {{ meta.by }}
      </div>
      <div
        v-if="(exclude && !exclude.includes('price')) || !exclude"
        class="th-cart-list-meta-price"
      >
        {{ thousandPrice(meta.price) }}
      </div>
    </div>
  </div>
</template>

<script>
import thousandPrice from '@/helpers/thousandPrice'
export default {
  props: ['meta', 'exclude', 'imgWidth'],
  data() {
    return {
      thousandPrice,
    }
  },
  methods: {
    toDetailCourse() {
      this.$router.push({ name: 'Detail Course', params: { id: this.meta.key } })
    },
  },
}
</script>

<style lang="scss">
@import "@/components/Kit/utils.scss";
.th-cart-list {
  display: flex;
  &-meta {
    display: flex;
    flex-direction: column;
    justify-content: center;
    &-title,
    &-price {
      font-weight: 600;
    }

    &-by {
      font-weight: 400;
      color: $gray2;
    }

    &-title {
      font-size: 14px;
    }

    &-by,
    &-price {
      font-size: 12px;
    }

    &-title,
    &-by,
    &-price {
      white-space: nowrap;
      // margin-bottom: 1px;
    }
  }

  &-image {
    margin-right: 10px;
    // background: linear-gradient(0deg, rgba(0, 0, 0, 0.51) 0%, rgba(255, 255, 255, 0) 100%);
    background: $white;
    // border-radius: $border-radius;
    height: 100%;

    img {
      border-radius: $border-radius;
    }
  }
}
</style>
